import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OrderEventsReturnsService } from '../../../../core/e-commerce/_services/order-events-returns-reports.service';
import { OrderEventBasketNewMaterial } from '../../../../core/models/orderEventBasketDto.model';
import { of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'kt-order-event-basket-add-material-modal',
  templateUrl: './new-material-for-order-event-basket.component.html',
  styleUrls: ["./new-material-for-order-event-basket.component.scss"]
})
export class AddOrderEventBasketMaterialModalComponent {
  searchTerm: string = '';
  filteredMaterials: OrderEventBasketNewMaterial[] = [];
  selectedMaterial: OrderEventBasketNewMaterial | null = null;
  searchTerm$ = new Subject<string>();

  constructor(
    public dialogRef: MatDialogRef<AddOrderEventBasketMaterialModalComponent>,
    private orderEventService: OrderEventsReturnsService
  ) {}


  ngOnInit() {
    this.searchTerm$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(term => {
        this.selectedMaterial = null;
        if (term.length > 2) {
          return this.orderEventService.searchMaterials(term);
        } else {
          return of([]);
        }
      })
    ).subscribe((materials: OrderEventBasketNewMaterial[]) => {
      this.filteredMaterials = materials;
    });
  }

  onSearchMaterial() {
    this.searchTerm$.next(this.searchTerm);
  }

  selectMaterial(material: OrderEventBasketNewMaterial) {
    this.selectedMaterial = material;
    this.searchTerm = `${material.code} - ${material.description}`;
    this.filteredMaterials = [];
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  addMaterial() {
    if (this.selectedMaterial) {
      this.dialogRef.close(this.selectedMaterial);
    }
  }
}
